// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3sFDc","label":"styles_label__37qSp","icon":"styles_icon__7ZJ4B","applied":"styles_applied__2ET6T"};